import { ToastContainer } from 'react-toastify'
import { DivInput, InputStyle, Span } from '../Users/Users.style'
import { SearchIcon } from '../../assets/icons/search'
import { colors } from '../../theme'
import {
  Container,
  SpanIcon,
  FilterStatus,
  SpanFilter,
  Ul,
  Td,
} from '../../layouts/LayoutTable/LayoutTable'
import { FilterIcon } from '../../assets/icons/filter'
import { ItemFilter } from '../../components/ItemFilter/ItemFilter'
import { GenericTable } from '../../components/GenericTable/GenericTable'

import { Button } from '../../components/SideBar/Menu.style'
import { DivTitle } from '../../components/TitlePage/TitlePage'
import { Pagination } from '../../components/Pagination/Pagination'
import { Loading } from '../../components/Loading/Loading'
import { useClientes } from './useClientes'
import SelectTexto from '../../components/MultipleSelect/SelectTexto'
import { SpanIconSegmento, FilterSegmento } from './Clientes.style'

export function Clientes() {
  const {
    searchValue,
    setSearchValue,
    isShowFilter,
    currentPage,
    setCurrentPage,
    clientes,
    fetchClientes,
    isLoading,
    handleKeyDown,
    goToPage,
    showFilter,
    statusChecked,
    statusCheckedTodos,
    setStatusCheckedFiltro,

    handleCheckboxChange,

    segmentos,
    carregandoCatalogo,
    valueSegmento,
    setValueSegmento,
    segmentoFiltrado,
    isShowSegmento,
    showSegmentoFilter,
    aplicarSegmento,
  } = useClientes()

  return (
    <div>
      <ToastContainer theme="dark" />
      <DivTitle color="black" size={22}>
        Clientes
      </DivTitle>
      <Container>
        <DivInput>
          <InputStyle
            value={searchValue}
            onChange={event => setSearchValue(event.target.value)}
            onKeyDown={handleKeyDown}
            border={colors.grey300}
            placeholder="Pesquisar cliente"
            sizeX="264px"
            sizeY="42px"
          />
          <Span onClick={fetchClientes}>
            <SearchIcon />
          </Span>
          <SpanIcon onClick={showFilter}>
            <FilterIcon />
          </SpanIcon>
          <SpanIconSegmento type="button" onClick={showSegmentoFilter}>
            <FilterIcon />
            Segmento
            {/* Conta o filtro APLICADO, nao o selecionado: fechar o painel sem clicar em Aplicar
                nao pode deixar o botao anunciando um filtro que a listagem nao esta usando. */}
            {segmentoFiltrado.length > 0 ? ` (${segmentoFiltrado.length})` : ''}
          </SpanIconSegmento>
          <div>
            {isLoading ? (
              <Loading contrast={false} />
            ) : (
              <>
                <GenericTable
                  size="270px"
                  headers={['Cliente', 'Status', 'Percentual']}
                  spacing="20px"
                  font="16px"
                >
                  {clientes.content &&
                    clientes.content.map(produto => (
                      <tr
                        onClick={() => goToPage(produto.id)}
                        className="itemTable"
                        key={produto.id}
                      >
                        {/* <td>{produto.id}</td> */}
                        <td className="col2">{produto.nome}</td>
                        <td className="col2">
                          <Td classification={produto.classificacao}>
                            {produto.classificacao
                              .replace('_', ' ')
                              .toLowerCase()}
                          </Td>
                        </td>
                        <td className="col3">
                          {String(produto.percentual).replace('.', ',')}%
                        </td>
                      </tr>
                    ))}
                </GenericTable>
                <Pagination
                  pageNumber={currentPage}
                  pageSize={clientes.totalElements}
                  offSet={clientes.size}
                  onClick={page => setCurrentPage(page)}
                />
              </>
            )}
          </div>
        </DivInput>

        {isShowFilter && (
          <FilterStatus>
            <SpanFilter>Filtrar por: </SpanFilter>

            <div>
              <Ul>
                <ItemFilter
                  top="2px"
                  checked={!statusCheckedTodos.includes('TODOS')}
                  onChange={() => {
                    // handleFiltroStatus(['Todos'])
                    handleCheckboxChange('TODOS')
                  }}
                  text="Todos"
                  id="all"
                />
                <ItemFilter
                  top="2px"
                  checked={statusChecked.includes('EM_ALTA')}
                  onChange={() => {
                    // handleFiltroStatus(['Em alta'])
                    handleCheckboxChange('EM_ALTA')
                  }}
                  text="Em alta"
                  id="onHigh"
                />
                <ItemFilter
                  top="2px"
                  checked={statusChecked.includes('EM_BAIXA')}
                  onChange={() => {
                    // handleFiltroStatus(['Em baixa'])
                    handleCheckboxChange('EM_BAIXA')
                  }}
                  text="Em baixa"
                  id="low"
                />
                <ItemFilter
                  top="2px"
                  checked={statusChecked.includes('NEUTRO')}
                  onChange={() => {
                    // handleFiltroStatus(['Neutro'])
                    handleCheckboxChange('NEUTRO')
                  }}
                  text="Neutro"
                  id="neutro"
                />
              </Ul>
            </div>
            <Button
              buttonType="SMALL"
              type="button"
              onClick={() => {
                setStatusCheckedFiltro(statusChecked)
                showFilter()
              }}
            >
              Aplicar
            </Button>
          </FilterStatus>
        )}

        {isShowSegmento && (
          <FilterSegmento>
            <SpanFilter>Filtrar por segmento: </SpanFilter>
            <SelectTexto
              opcoes={segmentos}
              value={valueSegmento}
              handle={setValueSegmento}
              placeholder="Selecione um ou mais segmentos"
              width
              carregando={carregandoCatalogo}
              vazio="Nenhum segmento cadastrado"
            />
            <Button buttonType="SMALL" type="button" onClick={aplicarSegmento}>
              Aplicar
            </Button>
          </FilterSegmento>
        )}
      </Container>
    </div>
  )
}
